import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Assets from "@/pages/Assets";
import AssetDetail from "@/pages/AssetDetail";
import Clients from "@/pages/Clients";
import Insurance from "@/pages/Insurance";
import NotificationSettings from "@/pages/NotificationSettings";
import Defects from "@/pages/Defects";
import Claims from "@/pages/Claims";
import Warranties from "@/pages/Warranties";
import Policies from "@/pages/Policies";
import Plans from "@/pages/Plans";
import Documents from "@/pages/Documents";
import TenantPortal from "@/pages/TenantPortal";
import ContractorPortal from "@/pages/ContractorPortal";
import Admin from "@/pages/Admin";
import HelpCenter from "@/pages/HelpCenter";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "tenant") return <Navigate to="/tenant" replace />;
  if (user.role === "contractor") return <Navigate to="/contractor" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/assets/:id" element={<AssetDetail />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/settings/notifications" element={<NotificationSettings />} />
            <Route path="/defects" element={<Defects />} />
            <Route path="/claims" element={<Claims />} />
            <Route path="/warranties" element={<Warranties />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/plans/:id" element={<Plans />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/tenant" element={<TenantPortal />} />
            <Route path="/contractor" element={<ContractorPortal />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/help-center" element={<HelpCenter />} />
          </Route>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
